import React from "react";
import { useState } from "react";
import { Button, Modal } from "react-bootstrap";

const PopUpModal = ({
  children,
  setmodalstate,
  showfooter = false,
  showheader = true,
  centered = false,
  backdrop = "static",
  size = "sm",
  title,
}) => {
  const [show, setShow] = useState(true);

  const handleClose = () => {
    setShow(false);
    setmodalstate(false);
  };

  return (
    <Modal
      show={show}
      size={size}
      keyboard={false}
      onHide={handleClose}
      backdrop={backdrop}
      centered={centered}
    >
      {showheader ? (
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
      ) : null}
      <Modal.Body>{children}</Modal.Body>

      {showfooter ? (
        <Modal.Footer className="justify-content-center">
          <Button
            className="w-100 btn btn-outline-secondary"
            onClick={handleClose}
          >
            Close
          </Button>
        </Modal.Footer>
      ) : null}
    </Modal>
  );
};

export default PopUpModal;
